import { getCounterEndTimeCookie } from 'common/utils/countdownCookie'

export const getNotExpiredStoredStartTime = (
  pageId: number,
  postFix: number | null,
) => {
  const endTime = Number(getCounterEndTimeCookie(pageId, postFix))
  return Number.isFinite(endTime) && endTime > Date.now() ? endTime : null
}
